import React from "react";
import Feature from "../../components/feature/Feature";
import "./whatPersbeTech.css";

const WhatPersbeTech = () => {
  return (
    <div className="pt__whatpt section__margin" id="wpt">
      <div className="pt__whatpt-heading">
        <h1 className="gradient__text">Welcome To Our World</h1>
        {/* <p>See Our Works</p> */}
      </div>
      <div className="pt__whatpt-feature">
        <Feature
          title="Who We Are?"
          text="Persbe Tech stands as a beacon of technological prowess, founded on the principles of 
          innovation, integrity, and ingenuity. With a team of seasoned professionals comprising software 
          engineers, designers, strategists, and industry experts, we are committed to delivering 
          unparalleled value to our clients through our expertise, passion, and unwavering dedication.
          Persbe Tech is your go-to destination for top-notch software solutions 
          tailored to meet your unique needs. Whether you're a small startup or a large enterprise, 
          we're here to help you navigate the digital landscape with confidence. At Persbe Tech, we 
          believe in the power of innovation to transform businesses. Our team of experts is dedicated 
          to crafting cutting-edge software that drives growth, enhances efficiency, and delivers real 
          results. From custom software development to UX/UI design and digital transformation services,
           we've got you covered. With Persbe Tech, you can expect nothing but the best. Our solutions
            are designed with your success in mind, prioritizing quality, reliability, and customer 
            satisfaction every step of the way. "
        />
      </div>

      <p className="pt__whatpt-intro"></p>

      <div className="pt__whatpt-container">
        <Feature
          title="OUR MISSION"
          text="At Persbe Tech, our mission is simple yet profound – to catalyze the success of businesses 
          through transformative software solutions that drive growth, efficiency, and sustainability. 
          We believe in leveraging the power of technology to empower our clients to realize their full potential and achieve their business objectives with confidence and conviction."
        />
        <Feature
          title="OUR VISION"
          text="Our vision at Persbe Tech is to be a driving force in the digital revolution, 
          pioneering groundbreaking innovations that redefine the way businesses operate, interact, 
          and thrive in the digital landscape. We aspire to be recognized globally as a trusted 
          partner and catalyst for digital transformation, setting new benchmarks of excellence in software development and technological innovation."
        />
        <Feature
          title="OUR CORE VALUES"
          text="We embrace innovation as the cornerstone of our identity, constantly pushing the 
          boundaries of what’s possible to deliver transformative solutions that propel our clients 
          to new heights of success. Also, integrity is our guiding principle. We conduct our business with honesty, 
          transparency, and integrity, building trust with our clients, partners, and stakeholders 
          through our actions, words, and deeds.  "
        />
      </div>
    </div>
  );
};

export default WhatPersbeTech;
